import { render, staticRenderFns } from "./GaleriaPrefeitos.vue?vue&type=template&id=49d080f2&"
import script from "./GaleriaPrefeitos.vue?vue&type=script&lang=js&"
export * from "./GaleriaPrefeitos.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaPrefeitos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports